import React from 'react';
import { useGoFormzAgent } from '../GoFormzAgentHook'; // Adjust the import path as needed

export default function AgentPopupSuggestions({ sendPromptForUser }: { sendPromptForUser: (key: string) => void }) {
  const { templateContext } = useGoFormzAgent();
  const [hasFieldValue, setHasFieldValue] = React.useState(() => !!(templateContext?.templateId && templateContext?.selectedCalculation));

  React.useEffect(() => {
    console.log('templateContext', templateContext);
    setHasFieldValue(templateContext?.templateId !== '' && templateContext?.selectedCalculation !== '');
  }, [templateContext?.templateId, templateContext?.selectedCalculation, templateContext]);

  const prompts = {
    explainFunction: 'Explain this formula to me in simple terms.',
    enhanceFunction: 'How can I enhance this formula?'
  };
  // Determine if the necessary template values exist using specific properties

  return (
    <div>
      <div className="ai-suggestions-header">Suggestions</div>
      <div className="ai-suggestions">
        {hasFieldValue && (
          <>
            <button onClick={() => sendPromptForUser(prompts.explainFunction)}>Explain Function</button>
            <button onClick={() => sendPromptForUser(prompts.enhanceFunction)}>Enhance Function</button>
          </>
        )}
      </div>
    </div>
  );
}
